import React from 'react';
import './MainLoader.scss';

function MainLoader() {
  return (
    <div className='loader-container'>
      <div className='spinner'></div>
    </div>
  );
}

export default MainLoader;
